import { PlusOutlined } from "@ant-design/icons"
import { Button, Typography } from "antd"
import React, { useState } from "react"
import { Link } from "react-router-dom"

import { CreateProjectWizard } from "../../../Project/ProjectAddPage/wizard/CreateProjectWizard.tsx"
import type { QuickAction } from "./_helpers.ts"

interface QuickActionsSectionProps {
  title: string
  actions: QuickAction[]
  labelFor: (action: QuickAction) => string
}

export const QuickActionsSection = ({
  title,
  actions,
  labelFor
}: QuickActionsSectionProps) => {
  const [openProjectWizard, setOpenProjectWizard] = useState(false)

  if (!actions.length) return null

  return (
    <section data-testid={"mobile-home-actions"}>
      <Typography.Title level={5} className={"!mb-2"}>
        {title}
      </Typography.Title>
      <div className={"flex flex-wrap gap-2"}>
        {actions.map((action) =>
          "to" in action ? (
            <Link
              key={action.key}
              to={action.to}
              className={"flex-1 min-w-[45%]"}
            >
              <Button type={"primary"} icon={<PlusOutlined />} block>
                {labelFor(action)}
              </Button>
            </Link>
          ) : (
            <Button
              key={action.key}
              type={"primary"}
              icon={<PlusOutlined />}
              block
              className={"flex-1 min-w-[45%]"}
              onClick={() => setOpenProjectWizard(true)}
            >
              {labelFor(action)}
            </Button>
          )
        )}
      </div>

      {openProjectWizard && (
        <CreateProjectWizard onClose={() => setOpenProjectWizard(false)} />
      )}
    </section>
  )
}
